import UpdateAnswer from "../../components/UpdateAnswer";
function UpdateAnswerPage() {
  return <UpdateAnswer />;
}

export default UpdateAnswerPage;
